import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-chevron-icon',
  templateUrl: './lib-chevron-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibChevronIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
